import { restResourceRequester } from "../rest-resource-requester";
import { CreateFileLayoutRequest } from "../data-kind/create-file-layout/CreateFileLayoutRequest";
import { CreateFileLayoutResponse } from "../data-kind/create-file-layout/CreateFileLayoutResponse";

interface DataKindsRestResource {
  createFileLayout(
    request: CreateFileLayoutRequest,
  ): Promise<CreateFileLayoutResponse>;
}

const REST_RESOURCE_NAME = {
  DATA_KIND: "/data-kind",
};
/**
 * PUT /create-file-layout
 */
const createFileLayout = restResourceRequester<
  CreateFileLayoutRequest,
  CreateFileLayoutResponse
>(
  "PUT",
  (request) => `${REST_RESOURCE_NAME.DATA_KIND}/${request.dtKindId}`,
  (request) => JSON.stringify(request),
);

export const DataKindsRestResource: DataKindsRestResource = {
  createFileLayout: createFileLayout,
};
